import it from './it.json';

const messages = {
  it,
};

const languagesCodes = {
  it: 'Italiano',
};

export {
  messages,
  languagesCodes,
};
